export default "__VITE_ASSET__Dmb86W6H__"